import EstimateStatus from "@/usecases/accounting/estimate-status";

const locale = {
  jp: {
    [EstimateStatus.Created]: "提出前",
    [EstimateStatus.Quoted]: "提出済",
    [EstimateStatus.Success]: "受注",
    [EstimateStatus.Failure]: "失注"
  }
};

export default {
  toJp(key: string): string {
    return locale.jp[key] || "";
  }
};
